import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Typography } from '@mui/material';
import { IoClose } from "react-icons/io5";
import { Box } from '@mui/material';

export default function RemarksDialog(props) {


    return (
        <React.Fragment>

            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >

                <DialogTitle id="alert-dialog-title">
                    <Typography variant='h4'>Remarks</Typography>
                </DialogTitle>
                <Box
                    sx={{
                        position: 'absolute',
                        top: 10,
                        right: 10,
                        cursor: 'pointer',
                        fontSize: '20px',
                    }}
                    onClick={props.handleClose}
                >
                    <IoClose />
                </Box>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <table>
                            <tr>
                                <td><Typography variant='h5'>Activation Remarks</Typography></td>
                                <td>:</td>
                                <td>{props.remarks}</td>
                            </tr>
                        </table>
                    </DialogContentText>
                </DialogContent>

            </Dialog>
        </React.Fragment>
    );
}
